module.exports = __webpack_public_path__ + "media/application/images/2018/email-blue-ae95385f72e530a3fe09686dee412679.svg";